"use client";

import type { PropsWithChildren } from "react";
import { Close } from "~/components/icons/32/Close";
import { useIssuuModal } from "~/components/ui/Issuu/lib/useIssuuModal";
import styles from "./issuu.module.css";

export const ClientIssuuRenderer = ({ children }: PropsWithChildren) => {
	const { isOpen, close } = useIssuuModal();
	return (
		<>
			{isOpen && (
				<div className={styles.modal}>
					<button className={styles["close-button"]}>
						<span className="sr-only">Lukk</span>
						<Close onClick={close} />
					</button>
					{children};
				</div>
			)}
		</>
	);
};
